export const searchBy: OptionType[] = [
  { key: 1, value: "User" },
  { key: 2, value: "Debtor" },
];
